import './App.css';
import AudioRecorder from './AudioRecorder';

function App() {
  return (
    <div>
      <AudioRecorder />
    </div>
  );
}

export default App;
